import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../api-entry-control.service';

@Component({
  selector: 'app-list-facility',
  templateUrl: './list-facility.component.html',
  styleUrls: ['./list-facility.component.css']
})
export class ListFacilityComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,

  ) { }
  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  ngOnInit(): void {
    this.get();
  }

  items: any;
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    q:new UntypedFormControl(''),
    active: new UntypedFormControl('')
  });
  delete() {
    this.api.deleteFacility(this.form).subscribe(
      (response) => {
        this.toast.success(
          'Instalacion y todas su dependencias fueron eliminadas',
          'Gestión instalaciones'
        );
        this.modal.dismissAll();
        this.get();
      },
      (e) => {
        
        this.toast.warning(e.error.mistakes,e.error.msg);
      }
    );
  }
  goToUpdate(id: number) {
    this.router.navigate(['control-ingreso/instalaciones/editar/' + id]);
  }

  get() {
    this.api.paginateFacility(this.page,this.form).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items;
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = [];
        this.page = 1;
      }
    );
  }
  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openDelete(id: number, md: any) {
    this.form.get('id').setValue(id);
    this.modal.open(md, {
      size: 'md',
    });
  }
  clean(){
    this.form.get('q').setValue('');
    this.form.get('active').setValue('');
    this.page=1;
    this.get();
  }

  filterChange() {
    this.page = 1;
    this.get();
  }

  search(q:string='') {
    if(q.length>=2){
      this.form.get('q').setValue(q);
      console.log('result q:',q);
      this.page=1;
    }
    this.get();
  }
}

